import Component from "../component";

export default class Events extends Component {
  constructor(...args) {
    super(...args);
  }
  init() {}
}
